import { ChakraProvider } from '@chakra-ui/react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { useEffect } from 'react';
import { animateScroll as scroll } from 'react-scroll'; // Import React Scroll
import theme from './styles/theme';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import BibleVerse from './components/BibleVerse';
import BioSection from './components/BioSection';
import ContactPage from './components/ContactPage';

function App() {
  const location = useLocation();

  // Scroll to the hash section when the URL changes
  useEffect(() => {
    if (location.hash) {
      const hash = location.hash.substring(1); // Remove the '#' from the hash
      const element = document.getElementById(hash);

      if (element) {
        scroll.scrollTo(element.offsetTop, {
          duration: 500,
          smooth: true,
          offset: -70, // Adjust for the sticky navbar height
        });
      }
    }
  }, [location]);

  return (
    <ChakraProvider theme={theme}>
      {/* Navbar */}
      <Navbar />

      {/* Animated Routes */}
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/verse" element={<BibleVerse />} />
          <Route path="/bio" element={<BioSection />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </AnimatePresence>

      {/* Footer */}
      <Footer />
    </ChakraProvider>
  );
}

export default App;
